import { useState, useEffect } from 'react';
import styles from './BootScreen.module.css';

const BOOT_MESSAGES = [
  { text: 'BIOS v2.4.1 - System Check', delay: 100 },
  { text: 'Memory: 32039 MB OK', delay: 150 },
  { text: 'Detecting drives...', delay: 200 },
  { text: 'Loading kernel...', delay: 250 },
  { text: 'Initializing services...', delay: 50 },
  { text: 'Starting window manager...', delay: 125 },
  { text: 'Welcome, visitor', delay: 500 },
];

interface BootScreenProps {
  onBootComplete: () => void;
}

export function BootScreen({ onBootComplete }: BootScreenProps) {
  const [messages, setMessages] = useState<string[]>([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [showCursor, setShowCursor] = useState(true);
  const [phase, setPhase] = useState<'booting' | 'done'>('booting');

  // Boot message sequence
  useEffect(() => {
    if (phase !== 'booting') return;
    if (currentIndex >= BOOT_MESSAGES.length) {
      const timer = setTimeout(() => {
        setPhase('done');
        onBootComplete();
      }, 800);
      return () => clearTimeout(timer);
    }

    const message = BOOT_MESSAGES[currentIndex];
    const timer = setTimeout(() => {
      setMessages(prev => [...prev, message.text]);
      setCurrentIndex(prev => prev + 1);
    }, message.delay);

    return () => clearTimeout(timer);
  }, [phase, currentIndex, onBootComplete]);

  // Cursor blink
  useEffect(() => {
    const interval = setInterval(() => {
      setShowCursor(prev => !prev);
    }, 530);
    return () => clearInterval(interval);
  }, []);

  if (phase === 'done') {
    return null;
  }

  return (
    <div className={`${styles.bootScreen} ${styles.booting}`}>
      <div className={styles.bootContent}>
        {phase === 'booting' && (
          <div className={styles.bootTerminal}>
            <div className={styles.bootHeader}>NickOS v1.0.0</div>
            <div className={styles.bootMessages}>
              {messages.map((msg, i) => (
                <div key={i} className={styles.bootLine}>
                  <span className={styles.bootPrefix}>[OK]</span> {msg}
                </div>
              ))}
              {currentIndex < BOOT_MESSAGES.length && (
                <div className={styles.bootLine}>
                  <span className={styles.bootCursor}>{showCursor ? '█' : ' '}</span>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
